import { LogEvent, LogError } from './types';
import { initDataDog, dataDogLog, AppName } from '@8fig/datadog';
import { isProd } from '..';
import { formatLogEvent } from './utils';

initDataDog({
  token: process.env.REACT_APP_DATADOG_TOKEN,
  env: process.env.REACT_APP_ENV,
  service: AppName.Frontend,
});

class Logger {
  async info({ message, data = {} }: LogEvent) {
    const event = await formatLogEvent({ message, data });
    if (isProd()) {
      dataDogLog.log(event);
    } else {
      console.log(event);
    }
  }

  async warn({ message, data = {} }: LogEvent) {
    const event = await formatLogEvent({ message, data });
    if (isProd()) {
      dataDogLog.warn(event);
    } else {
      console.warn(event);
    }
  }

  async error({ message, error, data = {} }: LogError) {
    const event = await formatLogEvent({ message, error, data });
    if (isProd()) {
      dataDogLog.error(event);
    } else {
      console.error(event);
    }
  }
}

export const logger = new Logger();
